import type { Moment } from 'moment';
import moment from 'moment';
import { OrderingConstants } from 'polygon-ordering';

const { SALE_TYPE } = OrderingConstants;

/**
 * # generateDateInRange()
 * Generates a set of dates (with "no time") based on these params:
 *
 * @param duration - Number of days
 * @param saleType
 * @param requiredTime - Only used if it's a catering saletype
 * @returns
 */
export const generateDateInRange = (
  duration: number,
  saleType: SALE_TYPE,
  requiredTime: Moment,
) => {
  const results = [];
  for (let i = 0; i < duration + 1; i++) {
    // We don't want time because it messes up the selection of the dropdown
    const initialDateWithNoTime = moment({ h: 0, m: 0, s: 0, ms: 0 });

    if (saleType === SALE_TYPE.CATERING || saleType === SALE_TYPE.CATERING_DELIVERY) {
      const futureDate = moment()
        .clone()
        .add(i, 'd')
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }); // Set times of dates to 00:00:00 to compare only dates

      if (requiredTime.diff(futureDate, 'day') <= 0) {
        results.push(initialDateWithNoTime.clone().add(i, 'd'));
      }
    } else {
      results.push(initialDateWithNoTime.clone().add(i, 'd'));
    }
  }

  return results;
};
